// extracted by mini-css-extract-plugin
module.exports = {"container":"Confirmation_container__30b1Z","title":"Confirmation_title__25feQ","actions":"Confirmation_actions__23QmZ","button":"Confirmation_button__3_VhC"};